import { orchestrator } from 'satcheljs';
import { getDateString } from 'owa-datetime';
import { setTaskId } from '../actions';
import patchAsset from '../utils/patchAsset';

orchestrator(
    setTaskId,
    ({ projectId, assetId, taskId, oldTaskId, taskDueDate, oldDueDate, onlySetLocally }) => {
        const taskDateStr = !!taskDueDate ? getDateString(taskDueDate) : '';
        const taskDateTz = taskDueDate?.tz ?? '';
        patchAsset(
            projectId,
            assetId,
            {
                taskId: taskId || '',
                // patch asset due date if a task due date exists
                ...(!!taskDueDate ? { dueDate: taskDateStr, dueDateTz: taskDateTz } : {}),
            },
            { taskId: oldTaskId, dueDate: oldDueDate },
            () => {
                return !onlySetLocally && taskId !== oldTaskId;
            }
        );
    }
);
